"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assetUrl = void 0;
var assetUrl = function (source) {
    var cdnUrl = process.env.NEXT_PUBLIC_CDN_HOST_URL || "/cdn";
    return cdnUrl + source;
};
exports.assetUrl = assetUrl;
//# sourceMappingURL=cdn.js.map